import { z } from 'zod';
export const healthStatusSchema = z.object({
    service: z.string().min(1),
    status: z.enum(['ok', 'degraded']),
    timestamp: z.iso.datetime(),
    version: z.string().min(1),
});
